import { CampaignStatusBadgeItemType } from "./campaignDataTypes.ts";
import { type SelectOption } from "@revmatics/catalyst";

export const campaignStatusBadgeData: CampaignStatusBadgeItemType = {
  off_track: "warning",
  on_track: "success",
  in_progress: "info",
  not_started: "default",
  deleted: "error",
  draft: "default",
};
export const campaignKPIOptions: SelectOption[] = [
  { value: "roas", label: "Return on Ad Spend (ROAS)" },
  { value: "cac", label: "Customer Acquisition Cost (CAC)" },
  { value: "cpm", label: "Cost per Impression (CPM)" },
  { value: "cpv", label: "Cost per View (CPV)" },
  { value: "cpi", label: "Cost per Install (CPI)" },
];
export const userRecommendationsOptions: SelectOption[] = [
  { value: "no_preference", label: "No preference" },
  { value: "nice_to_have", label: "Nice to have" },
  { value: "must_have", label: "Must have" },
  { value: "do_not_include", label: "Do not include" },
];
